import { CheckCircleTwoTone } from '@ant-design/icons';

export function DevelopScopeTabNavIcon() {
  return (
    <CheckCircleTwoTone
      twoToneColor={['var(--addition-classic-green-color)', 'transparent']}
    />
  );
}
